import request from 'utils/request'
import {stringify} from 'qs'
import api from './api'

// 自动群发列表
export async function getAutoMassSendingList(payload) {
    return request(`${api.getAutoMassSendingList.url}?${stringify(payload)}`)
}

// 订单详情列表
export async function getDetailTableList(payload) {
    return request(`${api.getDetailTableList.url}?${stringify(payload)}`)
}
